import { defineStore } from 'pinia';

import {
  GET_ALL_SELECTED_CRITERIA,
  UPDATE_SORTBY_SELECTED,
  REPLACE_SELECTED_VALUES,
  ADD_CHECKBOX_VALUES,
  REMOVE_CHECKBOX_VALUES_BY_VALUE,
  ADD_FACET_OPTIONS,
  ADD_SORT_BY_OPTIONS,
  ON_CLOSE_FACET_DROPDOWN,
} from '~/types/actions';

export const useFilteringFacetsStore = defineStore('filteringFacets', {
  state: () => ({
    facets: [],
    sortBy: {
      selectedValue: null,
      sortByOptions: [],
    },
    dropdownClosed: false,
  }),
  getters: {
    facetByName: (state) => (name) => state.facets.filter((facet) => facet.name === name)[0],
    allSelectedCriteria(state) {
      return {
        sortBy: state.sortBy.selectedValue,
        facets: state.facets
          .filter((facet) => facet.selectedValues && facet.selectedValues.length > 0)
          .map((facet) => ({
            name: facet.name,
            selectedValues: facet.selectedValues,
          })),
      };
    },
  },
  actions: {
    [ON_CLOSE_FACET_DROPDOWN]() {
      this.dropdownClosed = !this.dropdownClosed;
    },
    [GET_ALL_SELECTED_CRITERIA]() {
      // Use for consumer to subscribe this action
    },
    [ADD_FACET_OPTIONS](value) {
      this.facets = value.facets;
    },
    [ADD_SORT_BY_OPTIONS](value) {
      this.sortBy.selectedValue = value.sortBy[0].value;
      this.sortBy.sortByOptions = value.sortBy;
    },
    [UPDATE_SORTBY_SELECTED](value) {
      this.sortBy.selectedValue = value;
    },
    [REPLACE_SELECTED_VALUES](criteria) {
      const facet = this.facets.filter((_facet) => _facet.name === criteria.name);
      if (facet.length > 0) {
        facet[0].selectedValues = criteria.selectedValues;
      }
    },
    [ADD_CHECKBOX_VALUES](criteria) {
      const facet = this.facets.filter((_facet) => _facet.name === criteria.name);
      if (facet.length > 0) {
        facet[0].values.push(criteria.newValue);
      }
    },
    [REMOVE_CHECKBOX_VALUES_BY_VALUE](criteria) {
      const facet = this.facets.filter((_facet) => _facet.name === criteria.name);
      if (facet.length > 0) {
        facet[0].values = facet[0].values.filter((value) => value.value !== criteria.value);
      }
    },
  },
});
